var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_container"},[_c('my-title'),_vm._v(" "),_c('h2',[_vm._v("今回のランダムランチの組合せです")]),_vm._v(" "),_c('shop-list',{attrs:{"result":_vm.result}}),_vm._v(" "),_c('loading-modal'),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Top'}}},[_vm._v("Topに戻る")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01b35534","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/groupingResult/top.vue
// module id = null
// module chunks = 